import { taskOutputSchema } from "../task/output.mjs";
import { InternalCreateBaseSchema } from "./image.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/internal/taskEdit.ts
const ChatAspectRatio = z.enum([
	"1:1",
	"3:4",
	"4:3",
	"3:5",
	"5:3",
	"9:16",
	"16:9",
	"1:3",
	"3:1",
	"3:2",
	"2:3",
	"5:4",
	"4:5"
]);
const ChatResolution = z.enum([
	"1K",
	"2K",
	"4K"
]);
const ChatQuality = z.enum([
	"low",
	"medium",
	"high"
]);
const ChatModelConfigSchema = z.object({
	resolution: ChatResolution.optional(),
	aspectRatio: ChatAspectRatio.optional(),
	quality: ChatQuality.optional()
});
/**
* Internal edit task creation input.
* Extends InternalCreateBaseSchema (userId, source, creditAmount, priority,
* kotoneDetectionScene) with chat-edit-specific fields.
* inferenceProfile is omitted — it applies to image generation, not chat editing.
*/
const InternalEditCreateInputSchema = InternalCreateBaseSchema.omit({ inferenceProfile: true }).extend({
	prompt: z.string().min(1).max(4096),
	mediaIds: z.array(z.string().min(1)).min(1),
	modelId: z.string().min(1).optional(),
	workspaceId: z.string().min(1).optional(),
	modelConfig: ChatModelConfigSchema.optional(),
	callbackUrl: z.string().url().optional()
});
const internalTaskEditContract = oc.prefix("/internal/task/edit").tag("InternalTask").router({ create: oc.route({
	summary: "Create a chat-based image editing task on behalf of a user",
	description: "Creates a chat editing task for the specified user. Supports billing override, custom priority, and content moderation scene.",
	method: "POST",
	path: "/create",
	outputStructure: "detailed"
}).input(InternalEditCreateInputSchema).output(z.object({
	status: z.literal(201),
	body: taskOutputSchema
})).errors({ USER_NOT_FOUND: {
	status: 404,
	message: "User not found"
} }) });
//#endregion
export { InternalEditCreateInputSchema, internalTaskEditContract };
